import { useEffect } from "react";
import { createPortal } from "react-dom";
import { useIsMobile } from "@/core/hooks/useMediaQuery";

interface BasicDialogProps {
  open: boolean;
  children: React.ReactNode;
}

export function BasicDialog({ open, children }: BasicDialogProps) {
  const isMobile = useIsMobile();

  useEffect(() => {
    if (!open) return;

    const originalBodyOverflow = document.body.style.overflow;
    const originalHtmlOverflow = document.documentElement.style.overflow;

    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = originalBodyOverflow;
      document.documentElement.style.overflow = originalHtmlOverflow;
    };
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-50 bg-black/40">
      {/* Desktop Layout */}
      {!isMobile && (
        <div className="flex items-center justify-center min-h-full p-4">
          <div className="relative bg-white w-full max-w-[480px] max-h-[90vh] rounded-2xl shadow-lg flex flex-col gap-[20px] p-[30px] overflow-hidden">
            {children}
          </div>
        </div>
      )}

      {/* Mobile Layout */}
      {isMobile && (
        <div className="flex items-end justify-center min-h-full">
          <div className="relative bg-white w-full max-h-[90vh] rounded-t-xl shadow-lg flex flex-col overflow-hidden p-5">
            {children}
          </div>
        </div>
      )}
    </div>,
    document.body
  );
}
